import React from "react";
import MainPagetitle from "../../layouts/MainPagetitle";

export const PrivacyPolicy = () => {
  return (
    <>
      <MainPagetitle
        mainTitle="Privacy Policy"
        pageTitle="Privacy Policy"
        parentTitle="Home"
      />
      <div className="container-fluid cert_docs_container">
        <div class="card p-4">
          <h2 class="modal-title mb-3">Privacy policy</h2>
          <b>1. Introduction</b>
          <p>
            At SHATABDI LEAPROFIN PRIVATE LIMITED, we highly value the trust you place
            in us. We are committed to upholding ethical standards in the
            collection, usage, and protection of your information. Your privacy
            and security are of utmost importance to us. This Privacy Policy
            governs the use of our website, applications, products, and
            services. By accessing and using our website or services, you
            indicate your acceptance of this policy and our terms of use.
          </p>

          <b>2. Definitions</b>
          <p>
            Personal Data: Any information that can directly or indirectly
            identify an individual.
          </p>
          <p>
            Processing: Any operation or set of operations performed on personal
            data, whether by automated means or not, such as collection,
            recording, organization, storage, adaptation, and retrieval.
          </p>
          <p>Data Subject: An individual to whom personal data pertains.</p>

          <b>3. Data Collection</b>
          <p>We collect personal data for the following purposes:</p>
          <ul class="mb-3">
            <li>Identifying and verifying applicants for digital loans.</li>
            <li>Assessing creditworthiness.</li>
            <li>Processing loan applications.</li>
            <li>Servicing and managing loans.</li>
            <li>Complying with legal and regulatory requirements.</li>
          </ul>

          <p>
            We may collect the following types of personal data, among others:
          </p>
          <ul class="mb-3">
            <li>Contact information (name, address, email, phone number).</li>
            <li>Financial information (income, expenses, credit history).</li>
            <li>Identification information (government-issued ID).</li>
            <li>Employment and income details.</li>
            <li>Information related to loan transactions.</li>
          </ul>

          <b>4. Legal Basis for Processing</b>
          <p>We process personal data on the following legal bases:</p>

          <ul class="mb-3">
            <li>
              To perform the contract with the data subject (e.g., processing
              loan applications).
            </li>
            <li>
              To comply with legal obligations (e.g., regulatory reporting).
            </li>
            <li>Based on the data subject's consent when required.</li>
            <li>
              For legitimate interests (e.g., fraud prevention, risk
              assessment).
            </li>
          </ul>

          <b>5. Data Security</b>
          <p>
            We implement technical and organizational measures to protect
            personal data from unauthorized access, disclosure, alteration, and
            destruction. These measures include:
          </p>

          <ul class="mb-3">
            <li>Encryption of data in transit and at rest.</li>
            <li>Regular security assessments and audits.</li>
            <li>Access controls and authentication.</li>
            <li>Employee training on data security.</li>
          </ul>

          <b>6. Data Sharing</b>
          <p>We may share personal data with the following parties:</p>
          <ul>
            <li>Lending institutions and financial partners.</li>
            <li>Credit bureaus and reporting agencies.</li>
            <li>Legal and regulatory authorities.</li>
            <li>Service providers who assist with loan processing.</li>
          </ul>

          <p>
            We ensure that third parties have adequate data protection measures
            in place.
          </p>

          <b>7. Data Subject Rights</b>
          <p>Data subjects have the following rights:</p>
          <ul class="mb-3">
            <li>Right to access and rectify personal data.</li>
            <li>Right to erasure (where applicable).</li>
            <li>Right to restrict processing.</li>
            <li>Right to data portability.</li>
            <li>Right to object to processing.</li>
            <li>Right not to be subject to automated decision-making.</li>
          </ul>

          <p>
            To exercise these rights, please contact our Data Protection Officer
            (DPO) at [DPO contact details].
          </p>

          <b>8. Data Breach Response</b>
          <p>
            In the event of a data breach, we will notify affected data subjects
            and relevant authorities as required by law.
          </p>

          <b>9. Policy Updates</b>
          <p>
            We will regularly review and update this policy to stay compliant
            with data protection regulations. We encourage data subjects to
            periodically review this policy for any changes.
          </p>

          <b>10. Contact Information</b>
          <p>
            If you have any questions or concerns about this policy, please
            contact our Data Protection Officer (Amit Khanna) at
            0120-4832057/0120-3229778
          </p>
        </div>
      </div>
    </>
  );
};
